import { createSelector } from 'reselect';

const selectHalcyonFormCatalogItems = ({ halcyonFormCatalog }) => halcyonFormCatalog?.items || [];

export const selectHalcyonFormPickerOptions = createSelector(selectHalcyonFormCatalogItems, items =>
  items.map(({ internalCode, displayName, group }) => ({
    name: displayName,
    value: internalCode,
    group,
  })),
);
